import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Form from '@/containers/Subscription/Form';

import './index.scss';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '@/contexts/GlobalContext';
import { ROUTES } from '@/constants';

function Subscriptions() {
  const { t } = useTranslation();
  const { setPageTitle, setTriggerFetchProfile } = useContext(GlobalContext);

  useEffect(() => {
    setPageTitle({
      title: t('subscriptions_page.payment.page_title'),
      backUrl: ROUTES.SUBSCRIPTIONS.LIST,
    });
    setTriggerFetchProfile(true);
  }, [setPageTitle, t, setTriggerFetchProfile]);

  const { id } = useParams();
  return (
    <div className="subscriptions-page">
      <Form id={id} />
    </div>
  );
}

export default Subscriptions;
